import Vue from 'vue';
import Router from 'vue-router';
import Home from '@/components/Home';
import About from '@/components/About';
import Portfolio from '@/components/Portfolio';
import Contact from '@/components/Contact';

Vue.use(Router);

const router = new Router({
  routes: [
    { path: '/', name: 'Home', component: Home },
    { path: '/about', name: 'About', component: About },
    { path: '/portfolio', name: 'Portfolio', component: Portfolio },
    { path: '/contact', name: 'Contact', component: Contact },
  ],
});

router.afterEach(() => {
  setTimeout(() => {
    const evt = document.createEvent('UIEvents');
    evt.initUIEvent('resize', true, false, window, 0);
    window.dispatchEvent(evt);
  }, 250);
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js